import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { LocaleService } from '../i18n/locale.service';
import { PendingActionTracker } from '../shared/state/pending-action-tracker';
import { AccountsService } from './accounts.service';
import { FinanceDocumentKind } from './finance-document-download';

@Component({
    selector: 'app-finance-pdf-view-button',
    standalone: true,
    imports: [ButtonModule, TooltipModule],
    template: `
        <p-button icon="pi pi-file-pdf" severity="info" [rounded]="iconOnly" [text]="iconOnly"
            [outlined]="!iconOnly" [label]="iconOnly ? undefined : label"
            [pTooltip]="iconOnly ? label : undefined" [ariaLabel]="label"
            [loading]="actions.isPending('view')" [disabled]="disabled || !documentId"
            (onClick)="view()"></p-button>
    `
})
export class FinancePdfViewButtonComponent {
    @Input({ required: true }) kind!: FinanceDocumentKind;
    @Input() documentId?: number | null;
    @Input() documentReference?: string | null;
    @Input() postingStatus?: string | null;
    @Input() reprint = false;
    @Input() iconOnly = false;
    @Input() disabled = false;
    @Output() conflict = new EventEmitter<void>();

    readonly actions = new PendingActionTracker<'view'>();
    private readonly accounts = inject(AccountsService);
    private readonly locale = inject(LocaleService);

    get label(): string {
        this.locale.locale();
        return this.locale.translate(this.reprint ? 'financePdfViewer.viewReprint' : 'financePdfViewer.view');
    }

    view(): void {
        if (this.disabled) return;
        void this.accounts.viewPdfDocument(this.kind, this.documentId, this.documentReference,
            this.postingStatus, this.actions, 'view', this.reprint, () => this.conflict.emit());
    }
}
